// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("@assets/imgs/arrows/arrow_to_left_black.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "\n.verification-page {\n  padding: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.verification-page__back-link {\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n  padding-left: 15px;\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat 0 50% / 16px auto;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
